// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".common-dialog[data-v-059f4a0f] .el-dialog{width:var(--common-dialog-medium-width)}.common-dialog .el-form[data-v-059f4a0f]{margin-right:var(--common-dialog-form-margin-right)}", ""]);
// Exports
module.exports = exports;
